import { default as React, useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { TaskAlt } from '@mui/icons-material'
import ListAuthorizations from './ListAuthorizations'

import ListViewCommandBar from '../commandBar/ListViewCommandBar'
import Page from '../layout/Page'
import RoleContext from '../auth/RoleContext'
import { useLocalStorage } from '../utils/ReactUtils'

export default function ListAuthorizationsPage (props = {}) {
  const [isLoading, setIsLoading] = useState(true)
  const navigate = useNavigate()
  const roleDetails = useContext(RoleContext)

  const startLoading = () => {
    setIsLoading(true)
  }

  const stopLoading = () => {
    setIsLoading(false)
  }

  const breadcrumb = <span><TaskAlt/>&nbsp;Facility Authorizations</span>

  const [showFilters, setShowFilters] = useLocalStorage("showFilters", false)
  const toggleFilters = () => {
    setShowFilters(!showFilters);
  }

  const addRecord = () => {
    navigate('/facility-authorizations/create')
  }

  return (
        <Page { ...props} breadcrumb={breadcrumb} isLoading={isLoading} 
          commandBar={
            <ListViewCommandBar
              helpPage="/facility-authorizations/help"
              helpPageState={{
                backTo: '/facility-authorizations/list',
              }}
              loading={isLoading}
              filtersEnabled={showFilters}
              showFilters={true}
              toggleFilters={toggleFilters} 
              addRecord={addRecord} 
              showAdd={roleDetails.isQualityManager()}              
            />
          }>
            
          <ListAuthorizations showFilters={showFilters} startLoading={startLoading} stopLoading={stopLoading} />
        </Page>
      )
}